import { FormattedHTMLMessage } from "react-intl";

import { type VerificationService } from "../../lib/types/types";
import { FaqLinkComponent } from "../FaqLink/FaqLinkComponent";

interface Props {
  verificationService: VerificationService;
  isCentered?: boolean;
  variant?: "poweredby" | "verificationby" | "default";
}

const poweredByMessage = (
  <FormattedHTMLMessage id="poweredBy" defaultMessage="Verification services powered by SheerID." />
);

const PoweredByComponent = ({ verificationService, isCentered, variant = "default" }: Props) => {
  switch (variant) {
    case "poweredby":
      return (
        <div className="sid-footer__powered-by-container-experiment">
          <div className="sid-footer__powered-by_powerby-experiment">{poweredByMessage}</div>
          <div className="sid-footer__powered-by_powerby-experiment">
            <FaqLinkComponent verificationService={verificationService} />
          </div>
        </div>
      );
    case "verificationby":
      return (
        <div className="sid-footer__powered-by-container--stacked sid-l-horz-center sid-footer__powered-by-experiment">
          <div className="sid-footer__powered-by-verificationby-experiment">
            <div className="sid-footer__powered-by-icon-experiment">
              <img
                alt=""
                src="https://com-sheerid-resources.s3.us-east-1.amazonaws.com/common/images/2018/icons/sheerid_logo.svg"
              />
            </div>
            {poweredByMessage}
          </div>
        </div>
      );
    default:
      return (
        <div
          className={
            isCentered
              ? "sid-footer__powered-by-container--stacked sid-l-horz-center"
              : "sid-footer__powered-by-container"
          }
        >
          <div
            className={
              isCentered
                ? "sid-footer__powered-by--stacked sid-l-horz-center"
                : "sid-footer__powered-by"
            }
          >
            {poweredByMessage}
          </div>
          <div className={isCentered ? "sid-l-space-top-sm" : ""}>
            &nbsp;
            <FaqLinkComponent verificationService={verificationService} />
          </div>
        </div>
      );
  }
};

export { PoweredByComponent };
